const USER_DETAILS_LOADED_KEY = "userDetailsLoaded";
const PASS_DATA_KEY = "passData";
const ROLE_KEY = "role";

function parseJsonSafely(value) {
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

export function getPassData() {
  return parseJsonSafely(sessionStorage.getItem(PASS_DATA_KEY));
}

export function setPassData(value) {
  sessionStorage.setItem(PASS_DATA_KEY, JSON.stringify(value));
}

export function clearPassData() {
  sessionStorage.removeItem(PASS_DATA_KEY);
}

export function getStoredRole() {
  const role = sessionStorage.getItem(ROLE_KEY);

  if (!role || role === "undefined" || role === "null") {
    return "";
  }

  return role;
}

export function setStoredRole(role) {
  if (typeof role === "string" && role.trim() !== "") {
    sessionStorage.setItem(ROLE_KEY, role);
  } else {
    sessionStorage.removeItem(ROLE_KEY);
  }
}

export function clearStoredRole() {
  sessionStorage.removeItem(ROLE_KEY);
}

export function resolveStoredRole(roleMap, fallbackRole = "") {
  const storedRole = getStoredRole();

  if (storedRole && roleMap && roleMap[storedRole]) {
    return storedRole;
  }

  if (fallbackRole && roleMap && roleMap[fallbackRole]) {
    return fallbackRole;
  }

  // Some environments can return selectedRole as the translated display value
  // (e.g. "Project-Standards") instead of the AD group key. Resolve back to key.
  if (fallbackRole && roleMap) {
    const matchedRoleKey = Object.keys(roleMap).find(
      roleKey => roleMap[roleKey] === fallbackRole
    );

    if (matchedRoleKey) {
      return matchedRoleKey;
    }
  }

  const availableRoles = roleMap ? Object.keys(roleMap) : [];
  return availableRoles.length > 0 ? availableRoles[0] : "";
}

export function markUserDetailsLoaded(isLoaded) {
  sessionStorage.setItem(USER_DETAILS_LOADED_KEY, isLoaded ? "true" : "false");
}

export function isUserDetailsLoaded() {
  return sessionStorage.getItem(USER_DETAILS_LOADED_KEY) === "true";
}

export function hasPassData() {
  return !!getPassData();
}

export function isAuthReady() {
  return hasPassData() && isUserDetailsLoaded();
}